import React, { useState } from "react";
import { SaveCancel } from "../../components/PrimaryButton";
import Input from "../../components/Input";
import { useTranslation } from "react-i18next";
import { securePut } from "../../config/api";
import SnackbarNotification from '../../components/SnackbarNotification';

const TypeForm = ({ onSubmit, onCancel }) => {
  const [formValues, setFormValues] = useState({
    name: "",
    type: "STRING",
    values: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [saving, setSaving] = useState(false);
  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };
  
  const { t } = useTranslation();

  const handleInputChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const valuesArray = formValues.values
      .split(',')
      .map(value => value.trim())
      .filter(value => value !== "");
    
    if (!formValues.name) {
      setSnackbar({
        open: true,
        message: t('errors.typeNameRequired'),
        severity: 'error'
      });
      return;
    }
    
    if (valuesArray.length === 0) {
      setSnackbar({
        open: true,
        message: t('errors.typeValuesRequired'),
        severity: 'error'
      });
      return;
    }
    
    const payload = {
      name: formValues.name,
      type: formValues.type,
      values: valuesArray,
    };


    setSaving(true);
    try {
      const response = await securePut('/config/types/add', payload, showSnackbar);
      onSubmit();
    } catch (error) {
      console.error('Error adding type:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="bg-white px-12 py-8 rounded-[12px] shadow-lg w-full max-w-4xl">
        <h2 className="text-[32px] text-[#38485C] font-semibold mb-4 text-left">
          {t(`form_titles.add_type`)}
        </h2>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label={t(`fields.type.name`)}
                name="name"
                type="text"
                value={formValues.name}
                onChange={(value) => handleInputChange("name", value)}
                required
              />
              <Input
                label={t(`fields.type.type`)}
                name="type"
                type="dropdown"
                options={[
                  { value: "STRING", label: "STRING" },
                  { value: "INT", label: "INT" },
                ]}
                value={formValues.type}
                onChange={(value) => handleInputChange("type", value)}
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Input
              label={t(`fields.type.values`)}
              name="values"
              type="textarea"
              value={formValues.values}
              onChange={(value) => handleInputChange("values", value)}
              required
            />
            <p className="text-sm text-gray-500">
              {t('placeholder.values_hint')}
            </p>
          </div>

          <div className="flex justify-end space-x-4">
            <SaveCancel
              onCancelClick={onCancel}
              onSaveClick={handleSubmit}
              saving={saving}
            />
          </div>
        </form>
      </div>
      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
};

export default TypeForm;